import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { PostYield } from '../models/post-yield.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})
export class PostYieldService {
  constructor(private http: HttpClient) {}

  public getPostYield(): Observable<PostYield> {
    return this.http
      .get<PostYield>(`${PeriforApiEndpoint}/postYield`)
      .pipe(map(response => new PostYield({ ...response })));
  }

  public setPostYield(postYield: PostYield): Observable<unknown> {
    const requestPayload = {
      tubularStringId: postYield.tubularStringId,
      hollidayStressRatio: postYield.postYieldAnalsisParameters?.hollidayStressRatio ?? null
    };

    return this.http.put(`${PeriforApiEndpoint}/postYield`, requestPayload, httpOptions);
  }
}